import type { Strain, StrainQuery, StrainSummary } from '@shared';
import { strainsApi } from '../strainsApi';

/**
 * Read-only access to the existing server-backed catalogue for bootstrap.
 * Must not perform create/update/delete/archive/sync writes.
 */
export interface CatalogueBootstrapSource {
  list(query?: Partial<StrainQuery>): Promise<StrainSummary[]>;
  get(id: string): Promise<Strain>;
}

type StrainsApiLike = Pick<typeof strainsApi, 'list' | 'get'>;

/**
 * Bootstrap source backed by strainsApi list/get only.
 * Callers must not pass write-capable wrappers that mutate server state.
 */
export function createServerCatalogueBootstrapSource(
  api: StrainsApiLike = strainsApi,
): CatalogueBootstrapSource {
  return {
    list: (query = {}) => api.list(query),
    get: (id) => api.get(id),
  };
}
